import {
  closeicon,
  closered,
  emptycart,
  male,
  female,
  addIcon,
  subtractIcon,
} from "assets/icons/index";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { REMOVE_FROM_CART } from "redux/types";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { userGetCartItemsActions } from "redux/actions/Cart/userGetCartItemsActions";
import { useNavigate } from "react-router-dom";
import {
  INTERNAL_SEASONAL_DETAILS,
  HUMAN_PROJECT_DETAILS_PATH,
  ORPHAN_SPONSORSHIP_PATH,
} from "Routes/paths";
import { userDeleteCartItemsActions } from "redux/actions/Cart/userDeleteCartItemsActions";
import { notification, Spin } from "antd";
import { requestSecureUrlActions } from "redux/actions/RequestSecureUrl/requestSecureUrlActions";
import { userAdjustCartItemActions } from "redux/actions/Cart/userAdjustCartItemActions";

interface DonationCartProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const DonationCart = ({ show, setShow }: DonationCartProps) => {
  const [maleOrphanMonthCount, setMaleOrphanMonthCount] = useState<number[]>(
    [],
  );
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { cart } = useSelector((state: RootState) => state.guestCartReducer);

  ///////////////////////////////// logged in user cart
  const { userId, loginData } = useSelector(
    (state: RootState) => state.loginReducer,
  );

  const { userGetCartItemsLoading, userCartItems } = useSelector(
    (state: RootState) => state.userGetCartItemsReducer,
  );

  const { userAdjustCartItemLoading } = useSelector(
    (state: RootState) => state.userAdjustCartItemReducer,
  );

  const { deleteItemLoading } = useSelector(
    (state: RootState) => state.userDeleteCartItem,
  );

  //////////////////////////////// payment link
  const { requestSecureUrlLoading } = useSelector(
    (state: RootState) => state.requestSecureUrlReducer,
  );

  useEffect(() => {
    if (userId) {
      dispatch(userGetCartItemsActions(userId, i18n.language));
    }
  }, [userId]);

  useEffect(() => {
    if (userCartItems?.data?.orphan_projects) {
      const durations = userCartItems.data.orphan_projects.map(
        (item: any) => item?.cart_data?.duration || 0,
      );

      setMaleOrphanMonthCount(durations);
    }
  }, [userCartItems]);

  // console.log(cart);

  const handleIncrement = (index: number) => {
    setMaleOrphanMonthCount((prev) => {
      const newCount = [...prev];
      if (newCount[index] < 12) {
        newCount[index] += 1;
        dispatch(
          userAdjustCartItemActions(
            i18n.language,
            userId,
            {
              item: {
                id: userCartItems.data.orphan_projects[index].cart_data.item_id,
                op_type: "add",
              },
              project_type: "orphan",
              id: userCartItems.data.orphan_projects[index].id,
              duration: newCount[index],
            },
            () => {
              // console.log("hello");
              dispatch(userGetCartItemsActions(userId, i18n.language));
            },
          ),
        );
      } else {
        notification.warning({ message: "Maximum duration is 12 months" });
      }
      return newCount;
    });
  };

  const handleDecrement = (index: number) => {
    setMaleOrphanMonthCount((prev) => {
      const newCount = [...prev];
      if (newCount[index] > 1) {
        newCount[index] -= 1;
        dispatch(
          userAdjustCartItemActions(
            i18n.language,
            userId,
            {
              item: {
                id: userCartItems.data.orphan_projects[index].cart_data.item_id,
                op_type: "minus",
              },
              project_type: "orphan",
              id: userCartItems.data.orphan_projects[index].id,
              duration: newCount[index],
            },
            () => {
              dispatch(userGetCartItemsActions(userId, i18n.language));
            },
          ),
        );
      } else {
        notification.warning({ message: "Minimum duration is 1 month" });
      }
      return newCount;
    });
  };

  // console.log(userCartItems);
  // console.log(maleOrphanMonthCount);
  // console.log(
  //   cart.data.internal_projects.map((item: any) => ({
  //     id: item.id,
  //     amount: item.amount,
  //   }))
  // );

  return (
    <section
      data-aos={`${i18n.language === "en" ? "fade-right" : "fade-left"}`}
      data-aos-duration="300"
      className="absolute top-0 left-0 z-50 w-full h-screen bg-black/35 flex justify-end"
    >
      <div className="w-full lg:w-[424px] h-full bg-white p-[30px] flex flex-col gap-[20px]">
        {/* header  *********************************************/}
        <div className="flex items-center justify-between">
          <p
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-[24px] text-second_color`}
          >
            {t("Donation Cart")}
          </p>
          <img
            className="cursor-pointer"
            onClick={() => setShow(!show)}
            src={closeicon}
            alt=""
          />
        </div>
        {/* the cart content section  ***************************/}
        {loginData ? (
          //  loged in  user cart
          <>
            {userCartItems?.cart_summary?.total_items === 0 ? (
              ///////////////// case the cart is empty
              <div
                className={`w-full h-[400px] flex flex-col items-center justify-center gap-5 font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[500] text-[20px] lg:text-[24px] text-first_color`}
              >
                {" "}
                <p>{t("Donation cart is empty")}</p>
                <img className="w-[100px] h-[100px]" src={emptycart} alt="" />
              </div>
            ) : (
              //////////////////// case the cart has items
              <Spin spinning={userGetCartItemsLoading}>
                <div className="w-full max-h-[500px] lg:max-h-[650px] overflow-y-auto flex flex-col gap-[20px]">
                  {userCartItems?.data?.campaign_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.cart_data?.donation_amount}{" "}
                                    {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch(
                                    userDeleteCartItemsActions(
                                      i18n.language,
                                      userId,
                                      item?.cart_data?.item_id,
                                      {
                                        user_id: userId,
                                        item_id: item?.cart_data?.item_id,
                                      },
                                      () => {
                                        dispatch(
                                          userGetCartItemsActions(
                                            userId,
                                            i18n.language,
                                          ),
                                        );
                                      },
                                    ),
                                  );
                                  // dispatch({
                                  //   type: REMOVE_FROM_CART,
                                  //   payload: {
                                  //     id: item?.id,
                                  //   },
                                  // });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {userCartItems?.data?.external_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.cart_data?.donation_amount}{" "}
                                    {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch(
                                    userDeleteCartItemsActions(
                                      i18n.language,
                                      userId,
                                      item?.cart_data?.item_id,
                                      {
                                        user_id: userId,
                                        item_id: item?.cart_data?.item_id,
                                      },
                                      () => {
                                        dispatch(
                                          userGetCartItemsActions(
                                            userId,
                                            i18n.language,
                                          ),
                                        );
                                      },
                                    ),
                                  );
                                  // dispatch({
                                  //   type: REMOVE_FROM_CART,
                                  //   payload: {
                                  //     id: item?.id,
                                  //   },
                                  // });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {userCartItems?.data?.internal_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.cart_data?.donation_amount}{" "}
                                    {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch(
                                    userDeleteCartItemsActions(
                                      i18n.language,
                                      userId,
                                      item?.cart_data?.item_id,
                                      {
                                        user_id: userId,
                                        item_id: item?.cart_data?.item_id,
                                      },
                                      () => {
                                        dispatch(
                                          userGetCartItemsActions(
                                            userId,
                                            i18n.language,
                                          ),
                                        );
                                      },
                                    ),
                                  );
                                  // dispatch({
                                  //   type: REMOVE_FROM_CART,
                                  //   payload: {
                                  //     id: item?.id,
                                  //   },
                                  // });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {userCartItems?.data?.seasonal_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.cart_data?.donation_amount}{" "}
                                    {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch(
                                    userDeleteCartItemsActions(
                                      i18n.language,
                                      userId,
                                      item?.cart_data?.item_id,
                                      {
                                        user_id: userId,
                                        item_id: item?.cart_data?.item_id,
                                      },
                                      () => {
                                        dispatch(
                                          userGetCartItemsActions(
                                            userId,
                                            i18n.language,
                                          ),
                                        );
                                      },
                                    ),
                                  );
                                  // dispatch({
                                  //   type: REMOVE_FROM_CART,
                                  //   payload: {
                                  //     id: item?.id,
                                  //   },
                                  // });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {userCartItems?.data?.humanitarian_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.thumbnail_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${HUMAN_PROJECT_DETAILS_PATH}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.cart_data?.donation_amount}{" "}
                                    {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch(
                                    userDeleteCartItemsActions(
                                      i18n.language,
                                      userId,
                                      item?.cart_data?.item_id,
                                      {
                                        user_id: userId,
                                        item_id: item?.cart_data?.item_id,
                                      },
                                      () => {
                                        dispatch(
                                          userGetCartItemsActions(
                                            userId,
                                            i18n.language,
                                          ),
                                        );
                                      },
                                    ),
                                  );
                                  // dispatch({
                                  //   type: REMOVE_FROM_CART,
                                  //   payload: {
                                  //     id: item?.id,
                                  //   },
                                  // });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {userCartItems?.data?.orphan_projects?.map(
                    (item: any, i: number) => {
                      // console.log(item?.id);
                      return (
                        <Spin
                          key={`${item?.id}-${item?.cart_data?.duration}`}
                          spinning={
                            deleteItemLoading || userAdjustCartItemLoading
                          }
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  ***********/}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                {item?.gender === "Male" ? (
                                  <img
                                    className="w-[80px] h-[80px] rounded-[20px]"
                                    src={male}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    className="w-[80px] h-[80px] rounded-[20px]"
                                    src={female}
                                    alt=""
                                  />
                                )}
                              </div>

                              {/* content  **********/}
                              <div className="flex flex-col gap-[8px]">
                                <p
                                  onClick={() =>
                                    navigate(`${ORPHAN_SPONSORSHIP_PATH}`)
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.first_name_en
                                    : item?.first_name_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-second_color text-[12px]`}
                                  >
                                    ({item?.cart_data?.duration}) {t("Monthly")}
                                  </p>
                                </div>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[14px]`}
                                  >
                                    {item?.cart_data?.donation_amount}{" "}
                                    {t("AED")}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* increament and decreament  */}
                            <div>
                              <div className="w-[80px] h-[32px] bg-first_color/25 rounded-[15px] flex items-center justify-between ">
                                {/* decreament button *******/}
                                <div
                                  onClick={() => handleDecrement(i)}
                                  className="w-full h-full rounded-[15px] hover:bg-first_color duration-150 cursor-pointer flex items-center justify-center"
                                >
                                  <img
                                    className="w-[25px]"
                                    src={subtractIcon}
                                    alt=""
                                  />
                                </div>

                                {/* increament button *******/}
                                <div
                                  onClick={() => handleIncrement(i)}
                                  className="w-full h-full rounded-[15px] hover:bg-first_color duration-150 cursor-pointer flex items-center justify-center"
                                >
                                  <img
                                    className="w-[25px]"
                                    src={addIcon}
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch(
                                    userDeleteCartItemsActions(
                                      i18n.language,
                                      userId,
                                      item?.cart_data?.item_id,
                                      {
                                        user_id: userId,
                                        item_id: item?.cart_data?.item_id,
                                      },
                                      () => {
                                        dispatch(
                                          userGetCartItemsActions(
                                            userId,
                                            i18n.language,
                                          ),
                                        );

                                        setMaleOrphanMonthCount(
                                          (counts: any[]) => {
                                            const newCounts = counts.filter(
                                              (count: any) =>
                                                count.id !== item.id,
                                            );

                                            return newCounts;
                                          },
                                        );
                                      },
                                    ),
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}
                </div>

                {/* total amount  **************************************/}

                <div className="my-[10px] flex items-center justify-between">
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[400] text-[18px]`}
                  >
                    {t("Total Amount")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    }_Bold  text-[18px] text-first_color`}
                  >
                    {userCartItems?.cart_summary?.total_amount} {t("AED")}
                  </p>
                </div>

                {/* checkout button  ************************************/}

                <Spin spinning={requestSecureUrlLoading}>
                  <div
                    onClick={() => {
                      // userCartItems?.cart_summary?.total_items !== 0 &&
                      dispatch(
                        requestSecureUrlActions(
                          i18n.language,
                          userId,
                          {
                            device_info: null,
                            projects: {
                              campaign_projects:
                                userCartItems?.data?.campaign_projects?.map(
                                  (item: any) => ({
                                    id: item?.id,
                                    amount: item?.cart_data?.donation_amount,
                                  }),
                                ) || [],
                              internal_projects:
                                userCartItems?.data?.internal_projects?.map(
                                  (item: any) => ({
                                    id: item?.id,
                                    amount: item?.cart_data?.donation_amount,
                                  }),
                                ) || [],
                              seasonal_projects:
                                userCartItems?.data?.seasonal_projects?.map(
                                  (item: any) => ({
                                    id: item?.id,
                                    amount: item?.cart_data?.donation_amount,
                                  }),
                                ) || [],
                              humanitarian_projects:
                                userCartItems?.data?.humanitarian_projects?.map(
                                  (item: any) => ({
                                    id: item?.id,
                                    amount: item?.cart_data?.donation_amount,
                                  }),
                                ) || [],
                              orphan_projects:
                                userCartItems?.data?.orphan_projects?.map(
                                  (item: any) => ({
                                    id: item?.id,
                                    duration: item?.cart_data?.duration,
                                  }),
                                ) || [],
                              external_projects:
                                userCartItems?.data?.external_projects?.map(
                                  (item: any) => ({
                                    id: item?.id,
                                    amount: item?.cart_data?.donation_amount,
                                  }),
                                ) || [],
                            },
                          },
                          (urlLink: any) => {
                            setTimeout(() => {
                              window.open(`${urlLink?.message}`, "_blank");
                              // dispatch({ type: "SET_SecureUrlData" });
                            }, 1000);
                          },
                        ),
                      );
                    }}
                    className={`bg-first_color h-[48px] rounded-[15px] text-white font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] flex items-center justify-center cursor-pointer`}
                  >
                    {t("Donate Now")}
                  </div>
                </Spin>
              </Spin>
            )}
          </>
        ) : (
          // guest cart
          <>
            {cart?.totalItems === 0 ? (
              <div
                className={`w-full h-[400px] flex flex-col items-center justify-center gap-5 font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[500] text-[20px] lg:text-[24px] text-first_color`}
              >
                {" "}
                <p>{t("Donation cart is empty")}</p>
                <img className="w-[100px] h-[100px]" src={emptycart} alt="" />
              </div>
            ) : (
              /////////////////////////////////////////////// item
              <Spin spinning={userGetCartItemsLoading}>
                <div className="w-full max-h-[500px] lg:max-h-[650px] overflow-y-auto flex flex-col gap-[20px]">
                  {cart?.data?.campaign_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.amount} {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch({
                                    type: REMOVE_FROM_CART,
                                    payload: {
                                      category: "campaign_projects",
                                      projectId: item?.id,
                                    },
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {cart?.data?.external_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.amount} {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch({
                                    type: REMOVE_FROM_CART,
                                    payload: {
                                      category: "external_projects",
                                      projectId: item?.id,
                                    },
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {cart?.data?.internal_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.amount} {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch({
                                    type: REMOVE_FROM_CART,
                                    payload: {
                                      category: "internal_projects",
                                      projectId: item?.id,
                                    },
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {cart?.data?.seasonal_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${INTERNAL_SEASONAL_DETAILS}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.amount} {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch({
                                    type: REMOVE_FROM_CART,
                                    payload: {
                                      category: "seasonal_projects",
                                      projectId: item?.id,
                                    },
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}

                  {cart?.data?.humanitarian_projects?.map(
                    (item: any, i: number) => {
                      return (
                        <Spin key={i} spinning={deleteItemLoading}>
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-[20px]">
                              {/* picture  */}
                              <div className="w-[80px] h-[80px] rounded-[20px]">
                                <img
                                  className="w-[80px] h-[80px] rounded-[20px]"
                                  src={item?.image_url}
                                  alt=""
                                />
                              </div>

                              {/* content  */}
                              <div className="flex flex-col gap-[5px]">
                                <p
                                  onClick={() =>
                                    navigate(
                                      `${HUMAN_PROJECT_DETAILS_PATH}/${item?.id}`,
                                    )
                                  }
                                  className={`font-${
                                    i18n.language === "en"
                                      ? "Poppins"
                                      : "Almarai"
                                  } font-[600] text-[14px] text-second_color cursor-pointer`}
                                >
                                  {i18n.language === "en"
                                    ? item?.title_en
                                    : item?.title_ar}
                                </p>
                                <div className="flex items-center gap-[30px]">
                                  <p
                                    className={`font-${
                                      i18n.language === "en"
                                        ? "Poppins"
                                        : "Almarai"
                                    } font-[600] text-first_color text-[16px]`}
                                  >
                                    {item?.amount} {t("AED")}
                                  </p>

                                  {/* <img className="cursor-pointer" src={editprice} alt="" /> */}
                                </div>
                              </div>
                            </div>

                            {/* delet icon  */}
                            <div className="bg-red-200 p-[5px] rounded-[5px]">
                              <img
                                className="cursor-pointer"
                                src={closered}
                                alt=""
                                onClick={() => {
                                  dispatch({
                                    type: REMOVE_FROM_CART,
                                    payload: {
                                      category: "humanitarian_projects",
                                      projectId: item?.id,
                                    },
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </Spin>
                      );
                    },
                  )}
                </div>

                {/* total amount  **************************************/}

                <div className="my-[10px] flex items-center justify-between">
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[400] text-[18px]`}
                  >
                    {t("Total Amount")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    }_Bold  text-[18px] text-first_color`}
                  >
                    {cart?.totalPrice} {t("AED")}
                  </p>
                </div>

                {/* checkout button  ************************************/}

                <Spin spinning={requestSecureUrlLoading}>
                  <div
                    onClick={() => {
                      // userCartItems?.cart_summary?.total_items !== 0 &&
                      dispatch(
                        requestSecureUrlActions(
                          i18n.language,
                          userId ? userId : 0,
                          {
                            device_info: null,
                            projects: {
                              internal_projects:
                                cart.data.internal_projects.map(
                                  (item: any) => ({
                                    id: item.id,
                                    amount: item.amount,
                                  }),
                                ),
                              campaign_projects:
                                cart.data.campaign_projects.map(
                                  (item: any) => ({
                                    id: item.id,
                                    amount: item.amount,
                                  }),
                                ),
                              seasonal_projects:
                                cart.data.seasonal_projects.map(
                                  (item: any) => ({
                                    id: item.id,
                                    amount: item.amount,
                                  }),
                                ),
                              humanitarian_projects:
                                cart.data.humanitarian_projects.map(
                                  (item: any) => ({
                                    id: item.id,
                                    amount: item.amount,
                                  }),
                                ),
                              external_projects:
                                cart.data.external_projects.map(
                                  (item: any) => ({
                                    id: item.id,
                                    amount: item.amount,
                                  }),
                                ),
                              orphan_projects: [],
                            },
                          },
                          (urlLink: any) => {
                            setTimeout(() => {
                              window.open(`${urlLink?.message}`, "_blank");
                              // dispatch({ type: "SET_SecureUrlData" });
                            }, 1000);
                          },
                        ),
                      );
                    }}
                    className={`bg-first_color h-[48px] rounded-[15px] text-white font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] flex items-center justify-center cursor-pointer`}
                  >
                    {t("Checkout")}
                  </div>
                </Spin>
              </Spin>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default DonationCart;
